<template>
  <div>
    <a-card :bordered="false" class="header-solid h-full">
      <template #title>
        <a-row type="flex" align="middle" style="margin-bottom: 10px">
          <a-col
            :span="24"
            :md="24"
            style="
              display: flex;
              align-items: center;
              justify-content: flex-end;
            "
          >
            <a-input
              v-model="Query.skey"
              placeholder="模糊查询视频"
              size="small"
              style="width: 150px; margin-right: 10px"
            />
            <a-button
              type="primary"
              icon="search"
              size="small"
              style="margin-right: 10px"
              @click="SearchClieck()"
            >
              查询
            </a-button>
          </a-col>
        </a-row>

        <a-row type="flex" align="top" :gutter="16">
          <a-col :span="24">
            <a-table
              :columns="columns"
              :data-source="tableData"
              :pagination="false"
              size="small"
              :expandRowByClick="true"
            >
              <template slot="title" slot-scope="row">
                <div class="video-title">{{ row.title }}</div>
              </template>
              <template slot="urlItem1" slot-scope="row">
                <span class="icon" @click.stop="OpenVideo(row.urlItem1)">
                  <svg
                    t="1770703186074"
                    class="icon"
                    viewBox="0 0 1087 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="5571"
                    width="256"
                    height="256"
                  >
                    <path
                      d="M768 415.744q0 5.12-10.752 17.92t-23.04 30.208-23.04 37.888-10.752 41.984 10.752 41.472 23.04 36.352 23.04 27.136 10.752 13.824l0 107.52q0 17.408-12.8 39.424t-31.744 41.472-41.984 32.256-43.52 12.8l-508.928 0q-27.648 0-50.688-9.728t-40.448-27.136-27.136-40.96-9.728-51.2l0-441.344q0-20.48 9.216-42.496t26.112-40.448 39.936-30.72 50.688-12.288l508.928 0q27.648 0 51.712 9.728t41.984 26.624 28.16 40.448 10.24 50.176l0 89.088zM1086.464 319.488l0 467.968q0 22.528-11.776 39.936t-35.328 17.408q-8.192 0-20.992-6.144t-25.6-14.336-24.064-16.384-16.384-13.312q-13.312-11.264-40.448-38.912t-54.784-62.464-48.64-71.68-20.992-67.584 22.528-70.144 54.272-77.312 66.56-70.144 58.368-48.64q9.216-6.144 25.088-14.848t28.16-8.704q27.648 0 35.84 15.36t8.192 37.888l0 2.048z"
                      p-id="5572"
                      fill="#ffffff"
                    ></path>
                  </svg>
                </span>
              </template>
              <template slot="urlItem2" slot-scope="row">
                <span class="icon" @click.stop="OpenVideo(row.urlItem2)">
                  <svg
                    t="1770703186074"
                    class="icon"
                    viewBox="0 0 1087 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="5571"
                    width="256"
                    height="256"
                  >
                    <path
                      d="M768 415.744q0 5.12-10.752 17.92t-23.04 30.208-23.04 37.888-10.752 41.984 10.752 41.472 23.04 36.352 23.04 27.136 10.752 13.824l0 107.52q0 17.408-12.8 39.424t-31.744 41.472-41.984 32.256-43.52 12.8l-508.928 0q-27.648 0-50.688-9.728t-40.448-27.136-27.136-40.96-9.728-51.2l0-441.344q0-20.48 9.216-42.496t26.112-40.448 39.936-30.72 50.688-12.288l508.928 0q27.648 0 51.712 9.728t41.984 26.624 28.16 40.448 10.24 50.176l0 89.088zM1086.464 319.488l0 467.968q0 22.528-11.776 39.936t-35.328 17.408q-8.192 0-20.992-6.144t-25.6-14.336-24.064-16.384-16.384-13.312q-13.312-11.264-40.448-38.912t-54.784-62.464-48.64-71.68-20.992-67.584 22.528-70.144 54.272-77.312 66.56-70.144 58.368-48.64q9.216-6.144 25.088-14.848t28.16-8.704q27.648 0 35.84 15.36t8.192 37.888l0 2.048z"
                      p-id="5572"
                      fill="#ffffff"
                    ></path>
                  </svg>
                </span>
              </template>
              <template slot="urlItem3" slot-scope="row">
                <span class="icon" @click.stop="OpenVideo(row.urlItem3)">
                  <svg
                    t="1770703186074"
                    class="icon"
                    viewBox="0 0 1087 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="5571"
                    width="256"
                    height="256"
                  >
                    <path
                      d="M768 415.744q0 5.12-10.752 17.92t-23.04 30.208-23.04 37.888-10.752 41.984 10.752 41.472 23.04 36.352 23.04 27.136 10.752 13.824l0 107.52q0 17.408-12.8 39.424t-31.744 41.472-41.984 32.256-43.52 12.8l-508.928 0q-27.648 0-50.688-9.728t-40.448-27.136-27.136-40.96-9.728-51.2l0-441.344q0-20.48 9.216-42.496t26.112-40.448 39.936-30.72 50.688-12.288l508.928 0q27.648 0 51.712 9.728t41.984 26.624 28.16 40.448 10.24 50.176l0 89.088zM1086.464 319.488l0 467.968q0 22.528-11.776 39.936t-35.328 17.408q-8.192 0-20.992-6.144t-25.6-14.336-24.064-16.384-16.384-13.312q-13.312-11.264-40.448-38.912t-54.784-62.464-48.64-71.68-20.992-67.584 22.528-70.144 54.272-77.312 66.56-70.144 58.368-48.64q9.216-6.144 25.088-14.848t28.16-8.704q27.648 0 35.84 15.36t8.192 37.888l0 2.048z"
                      p-id="5572"
                      fill="#ffffff"
                    ></path>
                  </svg>
                </span>
              </template>
              <template slot="douyinLink" slot-scope="row">
                <span
                  class="icon"
                  @click.stop="
                    OpenVideo('https://www.douyin.com/video/' + row.awemeId)
                  "
                >
                  <svg
                    t="1770703186074"
                    class="icon"
                    viewBox="0 0 1087 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="5571"
                    width="256"
                    height="256"
                  >
                    <path
                      d="M768 415.744q0 5.12-10.752 17.92t-23.04 30.208-23.04 37.888-10.752 41.984 10.752 41.472 23.04 36.352 23.04 27.136 10.752 13.824l0 107.52q0 17.408-12.8 39.424t-31.744 41.472-41.984 32.256-43.52 12.8l-508.928 0q-27.648 0-50.688-9.728t-40.448-27.136-27.136-40.96-9.728-51.2l0-441.344q0-20.48 9.216-42.496t26.112-40.448 39.936-30.72 50.688-12.288l508.928 0q27.648 0 51.712 9.728t41.984 26.624 28.16 40.448 10.24 50.176l0 89.088zM1086.464 319.488l0 467.968q0 22.528-11.776 39.936t-35.328 17.408q-8.192 0-20.992-6.144t-25.6-14.336-24.064-16.384-16.384-13.312q-13.312-11.264-40.448-38.912t-54.784-62.464-48.64-71.68-20.992-67.584 22.528-70.144 54.272-77.312 66.56-70.144 58.368-48.64q9.216-6.144 25.088-14.848t28.16-8.704q27.648 0 35.84 15.36t8.192 37.888l0 2.048z"
                      p-id="5572"
                      fill="#ffffff"
                    ></path>
                  </svg>
                </span>
              </template>
              <template slot="editBtn" slot-scope="row">
                <el-button
                  type="primary"
                  round
                  size="small"
                  icon="el-icon-edit"
                  style="margin-right: 5px"
                  @click.stop="DouBaoClick(row)"
                  >总结</el-button
                >
              </template>

              <template slot="expandedRowRender" slot-scope="record">
                <el-form :data="record" label-width="80px">
                  <el-form-item label="视频标题：">
                    <label>{{ record.title }}</label>
                  </el-form-item>
                  <el-form-item label="视频原文：">
                    <label>{{ record.origText }}</label>
                  </el-form-item>
                  <el-form-item label="简要：">
                    <label>{{ record.simpleContentSummary }}</label>
                  </el-form-item>
                  <el-form-item label="总结：">
                    <label>{{ record.contentSummary }}</label>
                  </el-form-item>
                  <el-form-item label="关键字：">
                    <label>{{ record.keyWords }}</label>
                  </el-form-item>
                </el-form>

                <el-descriptions direction="vertical" :column="4" border>
                  <el-descriptions-item label="推荐数">{{
                    record.commentCount
                  }}</el-descriptions-item>
                  <el-descriptions-item label="评论数">{{
                    record.recommendCount
                  }}</el-descriptions-item>
                  <el-descriptions-item label="小心心数">{{
                    record.diggCount
                  }}</el-descriptions-item>
                  <el-descriptions-item label="钦佩数">{{
                    record.admireCount
                  }}</el-descriptions-item>
                  <el-descriptions-item label="播放数">{{
                    record.playCount
                  }}</el-descriptions-item>
                  <el-descriptions-item label="分享数">{{
                    record.shareCount
                  }}</el-descriptions-item>
                  <el-descriptions-item label="收藏数">{{
                    record.collectCount
                  }}</el-descriptions-item>
                </el-descriptions>
              </template>
            </a-table>
            <div class="PageCom">
              <el-pagination
                background
                :current-page="Page.index"
                :page-sizes="Page.sizes"
                :page-size="Page.size"
                :total="Page.total"
                layout="sizes, total, prev, pager, next"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              />
            </div>
          </a-col>
        </a-row>
      </template>
    </a-card>
  </div>
</template>

<script>
import { getShowBizVideoList, publishDoubaoTask } from "@/api/showbiz";
import store from "@/store";
export default {
  data() {
    return {
      receivedId: null,
      Query: {
        skey: "",
        pageIndex: 1,
        pageSize: 10,
      },
      columns: [
        {
          title: "发布时间",
          dataIndex: "createTime",
          key: "createTime",
          customRender: (text) => {
            if (!text) return "";
            const dateStr = text.toString();
            if (dateStr.length !== 14) return text;
            const year = dateStr.substring(0, 4);
            const month = dateStr.substring(4, 6);
            const day = dateStr.substring(6, 8);
            const hour = dateStr.substring(8, 10);
            const minute = dateStr.substring(10, 12);
            const second = dateStr.substring(12, 14);
            return `${year}年${month}月${day}日 ${hour}:${minute}:${second}`;
          },
        },
        {
          title: "视频标题",
          key: "title",
          scopedSlots: { customRender: "title" },
        },
        {
          title: "视频链接1",
          key: "urlItem1",
          scopedSlots: { customRender: "urlItem1" },
          maxWidth: "20px",
        },
        {
          title: "视频链接2",
          key: "urlItem2",
          scopedSlots: { customRender: "urlItem2" },
        },
        {
          title: "视频链接3",
          key: "urlItem3",
          scopedSlots: { customRender: "urlItem3" },
        },
        {
          title: "原网页",
          key: "awemeId",
          scopedSlots: { customRender: "douyinLink" },
        },
        {
          title: "最后更新时间",
          dataIndex: "lastUpdateTime",
          key: "lastUpdateTime",
          customRender: (text) => {
            if (!text) return "";
            const dateStr = text.toString();
            if (dateStr.length !== 14) return text;
            const year = dateStr.substring(0, 4);
            const month = dateStr.substring(4, 6);
            const day = dateStr.substring(6, 8);
            const hour = dateStr.substring(8, 10);
            const minute = dateStr.substring(10, 12);
            const second = dateStr.substring(12, 14);
            return `${year}年${month}月${day}日 ${hour}:${minute}:${second}`;
          },
        },
      ],
      Page: {
        index: 1,
        size: 10,
        sizes: [10, 50, 100, 200, 500, 1000],
        total: 0,
      },
      tableData: [],
      isAdmin: store.getters.roles.includes("admin"),
    };
  },
  created() {
    if (this.isAdmin) {
      this.columns.push({
        title: "操作",
        key: "editBtn",
        scopedSlots: { customRender: "editBtn" },
      });
    }
    this.receivedId = this.$route.query.id || null;
    this.GetTableData();
  },
  methods: {
    handleSizeChange(val) {
      this.Page.size = val;
      this.Query.pageSize = val;
      this.GetTableData();
    },
    handleCurrentChange(val) {
      this.Page.index = val;
      this.Query.pageIndex = val;
      this.GetTableData();
    },

    GetTableData() {
      getShowBizVideoList(
        this.receivedId,
        this.Query.skey,
        this.Query.pageIndex,
        this.Query.pageSize
      ).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list;
          this.Page.total = res.data.total;
        }
      });
    },
    SearchClieck() {
      this.GetTableData();
    },
    OpenVideo(url) {
      if (url) {
        window.open(url, "_blank", "noopener,noreferrer");
      }
    },
    DouBaoClick(row) {
      publishDoubaoTask([row.id]).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  display: inline-flex;
  width: 32px;
  height: 32px;
  background-color: #1296db;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  justify-content: center;
  align-items: center;
  margin: 7px;
  vertical-align: middle;
  cursor: pointer;
}

/* 视频标题样式 */
.video-title {
  min-width: 300px; /* 固定宽度 */
  word-break: break-all; /* 允许单词换行 */
  white-space: normal; /* 允许正常换行 */
  line-height: 1.4; /* 调整行高 */
}

/* 表单内容标签样式 */
.el-form-item label {
  word-break: break-all;
  white-space: normal;
  font-weight: bold;
  font-size: 16px;
}
</style>